import React, { useState, useEffect, useRef } from "react";
import Skeleton from "../Skeleton/Skeleton";
import "./LazyImage.scss";

const LazyImage = ({
  src,
  alt = "",
  title,
  width,
  height,
  className = "",
  wrapperClassName = "",
  style = {},
  wrapperStyle = {},
  loading = "lazy",
  fetchPriority,
  decoding = "async",
  onClick,
  onLoad,
  onError,
  skeletonWidth,
  skeletonHeight,
  skeletonBorderRadius,
  ...restProps
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setIsLoaded(false);
    setIsError(false);
    if (imgRef.current && imgRef.current.complete) {
      if (imgRef.current.naturalWidth > 0) {
        setIsLoaded(true);
      }
    }
  }, [src]);

  const handleLoad = (e) => {
    setIsLoaded(true);
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setIsLoaded(true);
    setIsError(true);
    if (onError) onError(e);
  };

  // Determine container dimensions to preserve layout space
  const containerStyle = {
    ...wrapperStyle,
    ...style,
  };

  if (width && width !== "100%" && width !== "auto") {
    containerStyle.width = typeof width === "number" ? `${width}px` : width;
  }
  if (height && height !== "100%" && height !== "auto") {
    containerStyle.height = typeof height === "number" ? `${height}px` : height;
  }

  return (
    <span
      className={`lazy-image-wrapper ${isLoaded ? "is-loaded" : "is-loading"} ${
        isError ? "is-error" : ""
      } ${wrapperClassName} ${className}`}
      style={containerStyle}
    >
      {!isLoaded && !isError && (
        <Skeleton
          width={skeletonWidth || "100%"}
          height={skeletonHeight || "100%"}
          borderRadius={skeletonBorderRadius}
          className="lazy-image-skeleton"
        />
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        title={title}
        width={width}
        height={height}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding={decoding}
        onClick={onClick}
        onLoad={handleLoad}
        onError={handleError}
        className={`lazy-image-element ${className}`}
        style={{
          opacity: isLoaded ? 1 : 0,
          display: isError ? "none" : "block",
        }}
        {...restProps}
      />
    </span>
  );
};

export default LazyImage;
